<template>
  <!-- Begin Page Content -->
  <div class="container-fluid">
    <div class="row justify-content-between">
      <div class="col">
        <h1 class="h3 mb-2 text-gray-800">Миний машинууд</h1>
      </div>
    </div>
    <div class="card my-4">
      <div class="card-header row m-0">
        <div class="col">
          <h4>ccccc</h4>
        </div>
        <div class="col-auto">
          <router-link v-bind:to="'/addcar/'">
            <div class="btn btn-success btn-sm">Машин нэмэх</div>
          </router-link>
        </div>
      </div>
      <div class="card-body">
        <div class="table-responsive">
          <table
            class="table table-bordered"
            id="dataTable"
            width="100%"
            cellspacing="0"
            v-if="cars!=null && cars.length>0"
          >
            <thead>
              <tr>
                <th>№</th>
                <th>Зураг</th>
                <th>Нэр</th>
                <th>Төлөв</th>
                <th>Үйлдэл</th>
              </tr>
            </thead>

            <tbody>
              <tr v-for="(car, index) in cars" v-bind:key="car.id">
                <td>{{index+1}}</td>
                <td>
                  <img
                    :src="_getImage(car)"
                    style="border: 1px solid #ddd; border-radius: 4px; padding: 5px; width: 50px;"
                  />
                </td>
                <td>{{car.name}}</td>

                <td>
                  <h6 v-if="car.published==true" style="cursor:pointer">
                    <span class="badge badge-success">Нээлттэй</span>
                  </h6>
                  <h6 v-else style="cursor:pointer">
                    <span class="badge badge-danger">Хаалттай</span>
                  </h6>
                </td>
                <td>
                  <div class="row">
                    <button class="btn btn-success btn-sm mx-1" @click="goDetail(car)">харах</button>
                    <!-- <button class="btn btn-warning btn-sm mx-1" @click="edit(car)">засах</button> -->
                    <router-link
                      :to="{ name: 'ImageAdd', params: { objectPath: 'cars/'+car.id, folderName: 'images_cars'}}"
                      class="btn btn-default btn-sm ml-2"
                    >Зураг оруулах</router-link>
                    <!-- <div class="btn btn-danger btn-sm mx-1" @click="askCopyLesson(lesson)">Copy</div> -->
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
          <div v-else class="alert alert-info text-center">Мэдээлэл оруулаагүй байна.</div>
        </div>
      </div>
    </div>
  </div>
  <!-- /.container-fluid -->
</template>

<script>
const fb = require("../../firebaseConfig.js");
import Vue from "vue";
import { mapState } from "vuex";
import { currentUser } from "../../firebaseConfig.js";
import moment from "moment";
export default {
  name: "Cars",
  data() {
    return {
      msg: "Cars",
      cars: [],
      trending: {
        content: []
      }
    };
  },
  computed: {
    ...mapState(["currentUser"])
  },
  created() {
    this._getObjects();
  },
  methods: {
    _getImage(obj) {
      if (obj.images != null && obj.images != undefined) {
        return obj.images[0]["fileUrl"];
      }
    },
    _getObjects() {
      var _this = this;
      var vm = this;

      fb.db
        .collection("cars")
        .where("user", "==", fb.usersCollection.doc(this.currentUser.uid))
        .onSnapshot(querySnapshot1 => {
          vm.cars = [];
          querySnapshot1.forEach(data => {
            let car = data.data();
            car.id = data.id;
            vm.cars.push(car);
          });
        });

      // fb.db
      //   .collection("semester")
      //   .get()
      //   .then(semestersSnapshot => {
      //     semestersSnapshot.forEach(semesterDoc => {
      //       let object = semesterDoc.data();
      //       object.id = semesterDoc.id;
      //       object.cars = [];
      //       fb.db
      //         .collection("cars")
      //         .where("user", "==", fb.usersCollection.doc(this.currentUser.uid))
      //         .onSnapshot(querySnapshot1 => {
      //           object.cars = [];
      //           querySnapshot1.forEach(lessonDoc => {
      //             let lesson = lessonDoc.data();
      //             lesson.id = lessonDoc.id;
      //             object.cars.push(lesson);
      //           });
      //         });
      //       _this.semesters.push(object);
      //     });
      //   });
    },
    goDetail(obj) {
      this.$router.push({
        name: "CarDetails",
        params: { lessonId: obj.id }
      });
    },
    edit(lesson) {
      this.$router.push({
        name: "LessonEdit",
        params: { lessonId: lesson.id }
      });
    }
  },
  filters: {
    formatDate(val) {
      if (!val) {
        return "-";
      }
      let date = val.toDate();
      return moment(date).fromNow();
    }
  }
};
</script>